import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";

export interface AlertModel {
  serasaObj;
}

@Component({
  selector: 'app-concentre',
  templateUrl: './concentre.component.html',
  styleUrls: ['./concentre.component.scss']
})
export class ConcentreComponent extends DialogComponent<AlertModel, boolean> implements AlertModel, OnInit {

  private participacaoSocietaria = [];
  serasaObj = [];

  constructor(dialogService: DialogService) {
    super(dialogService);
  }

  ngOnInit() {
    console.log(this.serasaObj);
    this.participacaoSocietaria = this.serasaObj['ParticipacaoSocietarias'].filter(element => element.Mensagem == null);
  }

  closeModal() {
    this.close();
  }

  sumTotais(obj) {
    let total = 0;
    for (var i = 0; i < obj.length; i++) {
      if (obj[i].ValorOcorrencia) {
        total += obj[i].ValorOcorrencia;
      }
      else if (obj[i].Valor) {
        total += obj[i].Valor;
      }
    }
    return total;
  }

  formataData(periodo) {
    return periodo.replace(/00:00:00/g, "");
  }
}



// WEBPACK FOOTER //
// ./src/app/serasa/component/serasa/concentre/concentre.component.ts